import { Button } from "primereact/button"
import styles from "../../../styles/Participant-GPRA.module.css"
import React, { useState, useContext, useEffect } from "react"
import { LoaderSmall } from "../../../components/Loaders"
import { UserContext } from "../../../context/userContext"
import { Dialog } from "primereact/dialog"
import { OrderList } from "primereact/orderlist"
import { convertAdditionalQuestionsOptions } from "../utils/utils"
import AddAdditionalQuestion from "./AddAdditionalQuestion"
import EditDefaultQuestion from "./EditDefaultQuestion"
import { INTERVIEW_SECTIONS } from "../types/interviewTypes"
import AddMatrix from "./AddMatrix"
import AddGroup from "./AddGroup"
import Matrix from "./Matrix"
import Group from "./Group"

const Questions = ({
  selectedOrganizations,
  disabled,
  setOrganizationError,
  organizationError,
  organizations,
  updateShowCustomizations,
  interviewType,
  section,
  setCustomizationChanges,
  customizationChanges,
  apply,
  saving,
  updateQuestions,
  questions,
  blocked,
}) => {
  const [showEditDefault, setShowEditDefault] = useState(false)
  const [editDefault, setEditDefault] = useState({})
  const [showConfirm, setShowConfirm] = useState(false)
  const userCtx = useContext(UserContext)
  const [formattedQuestions, setFormattedQuestions] = useState([])
  const [showAddAdditional, setShowAddAdditional] = useState(false)
  const [additionalQuestionToDelete, setAdditionalQuestionToDelete] =
    useState(null)
  const [additionalEditing, setAdditionalEditing] = useState(false)
  const [showAddMatrix, setShowAddMatrix] = useState(false)
  const [showAddGroup, setShowAddGroup] = useState(false)
  const [groupToDelete, setGroupToDelete] = useState(null)
  const [groupEditing, setGroupEditing] = useState(null)
  const [matrixEditing, setMatrixEditing] = useState(null)
  const [matrixToDelete, setMatrixToDelete] = useState(null)

  useEffect(() => {
    setFormattedQuestions(handleQuestions())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    questions?.additionalQuestions,
    questions?.defaultQuestions,
    questions?.matrices,
    questions?.groups,
  ])
  useEffect(() => {
    if (!saving) {
      setShowConfirm(false)
    }
  }, [saving])
  const correctSubstanceUseTitles = (title) => {
    switch (title) {
      case "Heroine":
        return "Opioids"
      case "Cannabis (Marijuana)":
        return "Cannabis"
      case "Sedatives":
        return "Sedative"
      case "Methamphetamine":
        return "Other Stimulants"
      case "PCP":
        return "Hallucinogens"
      case "Non-prescription GHB":
        return "Other Psychoactive"
      default:
        return title
    }
  }
  const correctTitles = (field, title) => {
    switch (field) {
      case "gpra_b_services_mod_1":
        return "Planned Services PROVIDED UNDER GRANT FUNDING"
      case "gpra_b_services_ts_1":
        return "Treatment Services"
      case "gpra_b_services_cm_1":
        return "Case Management Services"
      case "gpra_b_services_ms_1":
        return "Medical Services"
      case "gpra_b_services_acs_1":
        return "After Care Services"
      case "gpra_b_services_p2p_1":
        return "Peer-To-Peer Recovery Support Services"
      case "gpra_b_services_es_1":
        return "Education Services"
      case "gpra_k_mod_1":
        return "Case Management Services"
      case "gpra_k_ts_1":
        return "Treatment Services"
      case "gpra_k_cm_1":
        return "Case Management Services"
      case "gpra_k_acs_1":
        return "After Care Services"
      case "gpra_k_ms_1":
        return "Medical Services"
      case "gpra_k_ptp_1":
        return "Peer-To-Peer Recovery Support Services"
      case "gpra_k_es_1":
        return "Education Services"
      default:
        return title
    }
  }
  const filterDefaultQuestions = () => {
    let filteredQuestions = [...questions?.customizations]
    filteredQuestions = filteredQuestions?.filter(
      (q) => q.interviewType === interviewType && q.section === section
    )

    if (section === INTERVIEW_SECTIONS.SUBSTANCE_USE_1) {
      filteredQuestions = filteredQuestions?.filter(
        (q) => q.subQuestionNumber === 1 && q.label.includes("Days")
      )
    } else if (section === INTERVIEW_SECTIONS.PLANNED_SERVICES_1) {
      filteredQuestions = filteredQuestions?.filter(
        (q) => q.field === "gpra_b_services_mod_1"
      )
    } else if (section === INTERVIEW_SECTIONS.PLANNED_SERVICES_2) {
      filteredQuestions = filteredQuestions?.filter(
        (q) => q.field === "gpra_b_services_ts_1"
      )
    } else if (section === INTERVIEW_SECTIONS.PLANNED_SERVICES_3) {
      filteredQuestions = filteredQuestions?.filter(
        (q) =>
          q.field === "gpra_b_services_cm_1" ||
          q.field === "gpra_b_services_ms_1" ||
          q.field === "gpra_b_services_acs_1"
      )
    } else if (section === INTERVIEW_SECTIONS.PLANNED_SERVICES_4) {
      filteredQuestions = filteredQuestions?.filter(
        (q) =>
          q.field === "gpra_b_services_p2p_1" ||
          q.field === "gpra_b_services_es_1"
      )
    } else if (section === INTERVIEW_SECTIONS.SERVICES_RECEIVED_1) {
      filteredQuestions = filteredQuestions?.filter(
        (q) => q.field === "gpra_k_mod_1"
      )
    } else if (section === INTERVIEW_SECTIONS.SERVICES_RECEIVED_2) {
      filteredQuestions = filteredQuestions?.filter(
        (q) => q.field === "gpra_k_ts_1"
      )
    } else if (section === INTERVIEW_SECTIONS.SERVICES_RECEIVED_3) {
      filteredQuestions = filteredQuestions?.filter(
        (q) =>
          q.field === "gpra_k_cm_1" ||
          q.field === "gpra_k_acs_1" ||
          q.field === "gpra_k_ms_1"
      )
    } else if (section === INTERVIEW_SECTIONS.SERVICES_RECEIVED_4) {
      filteredQuestions = filteredQuestions?.filter(
        (q) => q.field === "gpra_k_ptp_1" || q.field === "gpra_k_es_1"
      )
    } else {
      filteredQuestions = filteredQuestions?.filter(
        (q) => !q.field.endsWith("section") && q.subQuestionNumber === null
      )
    }
    return filteredQuestions.sort((a, b) => {
      return a.questionNumber - b.questionNumber
    })
  }
  const formatDefaultQuestions = (filteredQuestions) => {
    return filteredQuestions?.map((question, index) => {
      return {
        number: question.questionNumber,
        title:
          section === INTERVIEW_SECTIONS.SUBSTANCE_USE_1
            ? correctSubstanceUseTitles(question.label.split("_")[0])
            : correctTitles(question.field, question.label),
        description: "",
        type: "",
        options: "",
        enabled: question.show,
        id: question.id,
        organization_id: question.organizationUuid,
        kind: "default",
        enterpriseCustomization: question.enterpriseCustomization,
        field: question.field,
        interviewType: question.interviewType,
        isEnterprise: question.isEnterprise,
        label: question.label,
        organizationId: question.organizationId,
        questionNumber: question.questionNumber,
        relatedTo: question.relatedTo,
        section: question.section,
        show: question.show,
        subQuestionNumber: question.subQuestionNumber,
        toggleOffBy: question.toggleOffBy,
        toggleOffDate: question.toggleOffDate,
        conditionalSource: question.conditionalSource,
        conditionalType: question.conditionalType,
        conditionalValue: question.conditionalValue,
        conditionalRequired: question.conditionalRequired,
        conditionalDisplay: question.conditionalDisplay,
      }
    })
  }
  const getAdditionalNumber = (number) => {
    if (number === 0) {
      return formattedQuestions.length + 1
    }
    return number
  }
  const handleQuestions = () => {
    let formattedAdditional = []
    let formattedMatrices = []
    let formattedGroups = []
    let filteredQuestions = filterDefaultQuestions()
    let formattedDefault = formatDefaultQuestions(filteredQuestions)
    formattedAdditional = questions?.additionalQuestions
      ?.filter(
        (a) =>
          a.section === section &&
          a.form === interviewType &&
          !a.deleted &&
          !a.questionGroup
      )
      ?.map((question) => {
        return {
          number: getAdditionalNumber(question.number),
          title: question.title,
          oldTitle: question.oldTitle,
          description: question.description,
          type: question.type,
          options: question.options,
          enabled: question.enabled,
          required: question.required,
          id: question.id,
          organization_id: question.organizationUuid,
          kind: "additional",
          updatedAt: question.updatedAt,
          enterpriseCustomization: question.enterpriseCustomization,
          isEnterprise: question.isEnterprise,
          section: question.section,
          subSection: question.subSection,
          form: question.form,
          questionGroup: question.questionGroup,
          conditionalSource: question.conditionalSource,
          conditionalType: question.conditionalType,
          conditionalValue: question.conditionalValue,
          conditionalRequired: question.conditionalRequired,
          conditionalDisplay: question.conditionalDisplay,
        }
      })
    formattedGroups = questions?.groups
      .filter(
        (a) =>
          a.section === section &&
          a.form === interviewType &&
          !a.deleted &&
          !a.matrixGroup
      )
      ?.map((question, index) => {
        return {
          number:
            question.number === 0
              ? filteredQuestions?.length + index + 1
              : question.number,
          title: question.title,
          oldTitle: question.oldTitle,
          description: question.description,
          type: question.type,
          options: question.options,
          enabled: question.enabled,
          expanded: question.expanded,
          required: question.required,
          id: question.id,
          organization_id: question.organizationUuid,
          kind: "group",
          updatedAt: question.updatedAt,
          enterpriseCustomization: question.enterpriseCustomization,
          isEnterprise: question.isEnterprise,
          section: question.section,
          subSection: question.subSection,
          form: question.form,
          matrixGroup: question.matrixGroup,
          groupOrder: question.groupOrder,
          alignment: question.alignment,
          additionalQuestions:
            !question?.additionalQuestions ||
            question?.additionalQuestions?.length === 0
              ? questions?.additionalQuestions
                  ?.filter(
                    (a) =>
                      a.questionGroup?.title === question.title &&
                      a.section === section &&
                      a.form === interviewType
                  )
                  .sort((a, b) => {
                    return a.groupOrder - b.groupOrder
                  })
              : question?.additionalQuestions
                  ?.sort((a, b) => {
                    return a.number - b.number
                  })
                  .map((a) => {
                    return { ...a, questionGroup: question }
                  }),
        }
      })
    formattedMatrices = questions?.matrices
      .filter(
        (a) => a.section === section && a.form === interviewType && !a.deleted
      )
      ?.map((question) => {
        const filterGroup = questions?.groups
          ?.filter(
            (g) =>
              g.section === section &&
              g.form === interviewType &&
              !g.deleted &&
              g.matrixGroup &&
              g.matrixGroup.title === question.title
          )
          .map((g) => {
            let update = { ...g }
            update.additionalQuestions = questions?.additionalQuestions?.filter(
              (a) =>
                a.form === interviewType &&
                a.section === section &&
                a.questionGroup?.title === g.title &&
                !a.deleted
            )
            return update
          })
        return {
          number: question.number,
          title: question.title,
          oldTitle: question.oldTitle,
          enabled: question.enabled,
          expanded: question.expanded,
          required: question.required,
          id: question.id,
          organization_id: question.organizationUuid,
          kind: "matrix",
          updatedAt: question.updatedAt,
          enterpriseCustomization: question.enterpriseCustomization,
          isEnterprise: question.isEnterprise,
          section: question.section,
          form: question.form,
          questionGroups: filterGroup,
        }
      })
    const result = [
      ...formattedDefault,
      ...formattedAdditional,
      ...formattedMatrices,
      ...formattedGroups,
    ].sort((a, b) => {
      return a.number - b.number
    })
    return result
  }
  if (saving && !showConfirm) {
    return <LoaderSmall></LoaderSmall>
  }
  const questionsButtons = () => {
    return (
      <>
        <div
          className={styles.interviewCardHeader}
          style={{
            display: "flex",
            justifyContent: "end",
            marginTop: "1rem",
            marginBottom: "1rem",
          }}
        >
          <div
            style={{
              borderRight: "2px",
              borderRightColor: "#adb5bd",
              borderRightStyle: "solid",
              paddingRight: "1rem",
            }}
          >
            <Button
              icon={saving ? "pi pi-spin pi-spinner" : "pi pi-save"}
              onClick={() => {
                if (organizations && organizations?.length > 0) {
                  setShowConfirm(true)
                } else {
                  setOrganizationError(true)
                }
              }}
              label="Save"
              disabled={disabled || !customizationChanges}
            />
            {organizationError && (
              <div style={{ marginTop: "1rem" }}>
                <label style={{ color: "red" }}>
                  Must select at least one Organization
                </label>
              </div>
            )}
          </div>
          <Button
            disabled={disabled || saving || blocked}
            onClick={() => {
              if (!blocked) {
                setShowAddAdditional(true)
              } else {
                setShowConfirm(true)
              }
            }}
            label="Add question"
            icon={"pi pi-plus"}
          />
          <Button
            disabled={disabled || saving || blocked}
            onClick={() => {
              if (!blocked) {
                setShowAddGroup(true)
              } else {
                setShowConfirm(true)
              }
            }}
            label="Add group"
            icon={"pi pi-plus"}
          />
          <Button
            disabled={disabled || saving || blocked}
            onClick={() => {
              if (!blocked) {
                setShowAddMatrix(true)
              } else {
                setShowConfirm(true)
              }
            }}
            label="Add matrix"
            icon={"pi pi-plus"}
          />
        </div>
      </>
    )
  }
  const confirmDialogContent = () => {
    if (!blocked) {
      if (
        userCtx.session.user.organization_id !==
        userCtx.session.user.enterprise_id
      ) {
        return (
          <p className="m-0">
            Are you sure you want to apply customizations to this organization?
            This may take a moment.
          </p>
        )
      } else {
        return (
          <>
            <p className="m-0">
              Are you sure you want to save customization changes? This may take
              a moment to complete.
            </p>
            <p className="m-0" style={{ marginTop: "1rem" }}>
              Please note:{" "}
              <i>
                Any changes saved will automatically propagate to all linked
                organizations.
              </i>
            </p>
          </>
        )
      }
    } else {
      return (
        <p
          className="m-0"
          style={{ marginBottom: "1rem", marginTop: "1rem", fontSize: "16px" }}
        >
          Some background sync/save jobs are still running, please try again in
          a few minutes
        </p>
      )
    }
  }
  const confirmDialog = () => {
    return (
      <div className="card flex justify-content-center">
        <Dialog
          header={"Please confirm"}
          visible={showConfirm}
          style={{ width: "40vw" }}
          onHide={() => setShowConfirm(false)}
          footer={!blocked && footerContent}
        >
          {confirmDialogContent()}
        </Dialog>
      </div>
    )
  }
  const footerContent = () => {
    return (
      <div>
        <Button
          label="No"
          icon={"pi pi-times"}
          onClick={() => setShowConfirm(false)}
          className="p-button-text"
          disabled={saving}
        />
        <Button
          label="Yes"
          icon={saving ? "pi pi-spin pi-spinner" : "pi pi-check"}
          onClick={() => {
            apply(
              true,
              questions?.additionalQuestions.filter(
                (a) => a?.section === section && a.form === interviewType
              ),
              questions?.matrices.filter(
                (m) => m?.section === section && m.form === interviewType
              ),
              questions?.groups.filter(
                (g) => g?.section === section && g.form === interviewType
              ),
              questions?.customizations,
              interviewType
            )
          }}
          disabled={saving}
          autoFocus
        />
      </div>
    )
  }
  const renderDefaultItem = (item) => {
    return (
      <div
        style={{
          display: "inline-grid",
          gridTemplateColumns:
            "50px 300px 200px 50px 300px 50px 50px 50px 100px",
          columnGap: "50px",
          marginLeft: "20px",
        }}
      >
        <div>{item.number}</div>
        <div>{item.title}</div>
        <div>{item.description}</div>
        <div>{item.type}</div>
        <div>{item.options}</div>
        <div>{item.enabled ? "Yes" : "No"}</div>
        <div>
          {item.kind === "additional" ? (item.required ? "Yes" : "No") : ""}
        </div>
        <div>{item.kind}</div>
        <div
          style={{
            display: "flex",
            gap: "10px",
            flex: "1",
            alignSelf: "baseline",
          }}
        >
          <Button
            disabled={disabled || item.title === "Interview Date" || blocked}
            onClick={() => {
              if (!blocked) {
                if (item.kind === "additional") {
                  setAdditionalEditing({
                    id: item.id,
                    description: item.description,
                    number: item.number,
                    type: item.type,
                    title: item.title,
                    oldTitle: item.title,
                    options: Array.isArray(item.options)
                      ? item.options
                      : convertAdditionalQuestionsOptions(item.options),
                    enabled: item.enabled,
                    required: item.required,
                    editing: true,
                    grouped: false,
                    section: item.section,
                    interviewType: item.form,
                    conditionalSource: item.conditionalSource,
                    conditionalType: item.conditionalType,
                    conditionalValue: !item.conditionalValue
                      ? ""
                      : item.conditionalValue,
                    conditionalRequired: item.conditionalRequired,
                    conditionalDisplay: item.conditionalDisplay,
                  })
                  setShowAddAdditional(true)
                }
                if (item.kind === "default") {
                  setEditDefault({
                    enterpriseCustomization: item.enterpriseCustomization,
                    field: item.field,
                    id: item.id,
                    interviewType: item.interviewType,
                    isEnterprise: item.isEnterprise,
                    label: item.label,
                    organizationId: item.organizationId,
                    questionNumber: item.questionNumber,
                    relatedTo: item.relatedTo,
                    section: item.section,
                    show: item.show,
                    subQuestionNumber: item.subQuestionNumber,
                    toggleOffBy: item.toggleOffBy,
                    toggleOffDate: item.toggleOffDate,
                    conditionalSource: item.conditionalSource,
                    conditionalType: item.conditionalType,
                    conditionalValue: !item.conditionalValue
                      ? ""
                      : item.conditionalValue,
                    conditionalDisplay: item.conditionalDisplay,
                    conditionalRequired: item.conditionalRequired,
                  })
                  setShowEditDefault(true)
                }
              } else {
                setShowConfirm(true)
              }
            }}
            icon="pi pi-pencil"
            style={{ marginRight: "20px" }}
          />
          <Button
            disabled={disabled || item.kind === "default" || blocked}
            onClick={() => {
              if (!blocked) {
                setAdditionalQuestionToDelete(item)
              } else {
                setShowConfirm(true)
              }
            }}
            icon="pi pi-times"
            style={{ backgroundColor: "red" }}
          />
        </div>
      </div>
    )
  }
  const renderMatrixItem = (item) => {
    return (
      <Matrix
        item={item}
        setAdditionalQuestionToDelete={setAdditionalQuestionToDelete}
        setAdditionalEditing={setAdditionalEditing}
        disabled={disabled}
        setShowAddAdditional={setShowAddAdditional}
        setGroupToDelete={setGroupToDelete}
        setShowAddGroup={setShowAddGroup}
        setGroupEditing={setGroupEditing}
        setMatrixEditing={setMatrixEditing}
        setMatrixToDelete={setMatrixToDelete}
        setShowAddMatrix={setShowAddMatrix}
        updateQuestions={updateQuestions}
        questions={questions}
        blocked={blocked}
        setShowConfirm={setShowConfirm}
      />
    )
  }
  const renderGroupItem = (item) => {
    return (
      <Group
        disabled={disabled}
        setShowAddAdditional={setShowAddAdditional}
        setShowAddGroup={setShowAddGroup}
        setGroupEditing={setGroupEditing}
        setGroupToDelete={setGroupToDelete}
        setAdditionalEditing={setAdditionalEditing}
        setAdditionalQuestionToDelete={setAdditionalQuestionToDelete}
        questions={questions}
        updateQuestions={updateQuestions}
        group={item}
        blocked={blocked}
        setShowConfirm={setShowConfirm}
      />
    )
  }
  const itemTemplate = (item) => {
    if (item.kind === "group") {
      return renderGroupItem(item)
    }
    if (item.kind === "matrix") {
      return renderMatrixItem(item)
    }
    return renderDefaultItem(item)
  }
  const listHeader = () => {
    return (
      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "50px 300px 200px 50px 300px 50px 50px 50px 100px",
          columnGap: "50px",
        }}
      >
        <span>Number</span>
        <span>Title</span>
        <span>Description</span>
        <span>Type</span>
        <span>Options</span>
        <span>Enabled</span>
        <span>Required</span>
      </div>
    )
  }
  const setNumbers = (values) => {
    let index = formattedQuestions[0]?.number - 1
    const newValues = values?.map((value) => {
      const newValue = { ...value, number: index + 1 }
      index = index + 1
      return newValue
    })
    const additionalQuestions = newValues.filter((v) => v.kind === "additional")
    const matrixQuestions = newValues.filter((m) => m.kind === "matrix")
    const updatedMatrices = questions?.matrices?.map((matrix) => {
      let newValue = { ...matrix }
      const newNumber = matrixQuestions?.find(
        (mq) => mq.title === matrix.title
      )?.number
      if (newNumber) {
        newValue.number = newNumber
      }
      return newValue
    })
    const defaultQuestions = newValues.filter((v) => v.kind === "default")
    const defaultUpdated = questions.customizations?.map((s) => {
      const newCustomization = defaultQuestions.find((c) => c.id === s.id)
      let newValue = { ...s }
      if (newCustomization) {
        newValue.questionNumber = newCustomization.number
      }
      return newValue
    })
    const additionalUpdated = questions?.additionalQuestions?.map((a) => {
      let newValue = { ...a }
      const newAdditional = additionalQuestions.find((n) => n.title === a.title)
      if (newAdditional) {
        newValue.number = newAdditional.number
      }
      return newValue
    })
    const groups = newValues?.filter((g) => g.kind === "group")
    const groupsUpdated = questions?.groups?.map((g) => {
      let newValue = { ...g }
      const newGroup = groups.find((n) => n.title === g.title)
      if (newGroup) {
        newValue.number = newGroup.number
      }
      return newValue
    })
    updateQuestions({
      ...questions,
      matrices: updatedMatrices,
      groups: groupsUpdated,
      additionalQuestions: additionalUpdated.map((question) => {
        return buildAdditionalQuestion(question)
      }),
      customizations: defaultUpdated,
    })

    setFormattedQuestions(newValues)
  }
  const buildAdditionalQuestion = (data) => {
    return {
      id: data.id,
      organizationUuid: data.organization_id,
      form: data.form,
      section: data.section,
      subSection: data.subSection,
      title: data.title,
      oldTitle: data.oldTitle,
      description: data.description,
      type: data.type,
      options: data.options
        ? Array.isArray(data.options)
          ? data.options
          : convertAdditionalQuestionsOptions(data.options)
        : undefined,
      enabled: data.enabled,
      required: data.required,
      number: data.number,
      organizations: organizations,
      selectedOrganizations: selectedOrganizations,
      isEnterprise: data.isEnterprise,
      enterpriseCustomization: data.enterpriseCustomization,
      deleted: data.deleted,
      questionGroup: data.questionGroup,
      groupOrder: data.groupOrder,
      conditionalDisplay: data.conditionalDisplay,
      conditionalRequired: data.conditionalRequired,
      conditionalSource: data.conditionalSource,
      conditionalType: data.conditionalType,
      conditionalValue: data.conditionalValue,
    }
  }
  const changeAdditionalPosition = (data, additionalTitle, remove) => {
    let formattedUpdated = []

    formattedUpdated = formattedQuestions
      .filter((f) => f.title !== additionalTitle)
      ?.map((f, index) => {
        return { ...f, number: index + 1 }
      })
    const updatedAdditionals = data?.additionalQuestions?.map((additional) => {
      let newValue = { ...additional }
      if (!remove) {
        if (additional.questionGroup) {
          const additionalGroupsNumbersUpdated = data?.groups
            ?.find((g) => g.title === additional?.questionGroup.title)
            ?.additionalQuestions?.filter(
              (a) =>
                a.section === section && a.form === interviewType && !a.deleted
            )
            ?.map((a, index) => {
              return { ...a, groupOrder: index + 1, number: index + 1 }
            })
          if (additionalGroupsNumbersUpdated) {
            const updated = additionalGroupsNumbersUpdated.find(
              (a) => a.title === additional.title
            )
            if (updated) {
              newValue.number = updated.number
              newValue.groupOrder = updated.groupOrder
            }
          }
          return newValue
        } else {
          const newNumber = formattedUpdated.find(
            (f) => f.kind === "additional" && f.title === additional.title
          )
          if (newNumber) {
            newValue.number = newNumber.number
          }
        }
      } else {
        if (additional.title === additionalTitle) {
          newValue.number = formattedQuestions.length + 1
        }
      }

      return newValue
    })
    const updatedMatrices = data?.matrices?.map((matrix) => {
      const newNumber = formattedUpdated.find(
        (f) => f.kind === "matrix" && f.title === matrix.title
      )
      let newValue = { ...matrix }
      if (newNumber) {
        newValue.number = newNumber.number
      }
      return newValue
    })
    const updatedGroups = data?.groups?.map((group) => {
      const newNumber = formattedUpdated.find(
        (f) => f.kind === "group" && f.title === group.title
      )
      let newValue = { ...group }
      if (newNumber) {
        newValue.number = newNumber.number
      }
      if (newValue.additionalQuestions?.length > 0) {
        const updatedAdditionalQuestions = newValue?.additionalQuestions?.map(
          (g, index) => {
            return { ...g, groupOrder: index + 1, number: index + 1 }
          }
        )
        newValue.additionalQuestions = updatedAdditionalQuestions
      }
      return newValue
    })
    const updatedDefault = data?.customizations?.map((def) => {
      const newNumber = formattedUpdated.find((f) => f.title === def.title)
      let newValue = { ...def }
      if (newNumber) {
        newValue.questionNumber = newNumber.number
      }
      return newValue
    })
    updateQuestions({
      ...questions,
      matrices: updatedMatrices,
      customizations: updatedDefault,
      additionalQuestions: updatedAdditionals,
      groups: updatedGroups,
    })
  }
  const deleteAdditional = () => {
    if (!additionalQuestionToDelete.grouped) {
      const formattedFiltered = formattedQuestions.filter(
        (f) => f.title !== additionalQuestionToDelete.title
      )

      const formattedUpdated = formattedFiltered.map((f, index) => {
        return { ...f, number: index + 1 }
      })

      const markDeleted = formattedQuestions.map((q) => {
        if (q.title === additionalQuestionToDelete.title) {
          return { ...q, deleted: true }
        } else {
          return q
        }
      })
      const markedWithNewNumbers = markDeleted?.map((q) => {
        const newAdditional = formattedUpdated.find((d) => d.title === q.title)
        let newValue = { ...q }
        if (newAdditional) {
          newValue.number = newAdditional.number
          newValue.deleted = newAdditional.deleted
        }
        return newValue
      })
      const additionalQuestions = markedWithNewNumbers.filter(
        (v) => v.kind === "additional"
      )
      const defaultQuestions = formattedUpdated.filter(
        (v) => v.kind === "default"
      )
      const defaultUpdated = questions.customizations?.map((s) => {
        const newCustomization = defaultQuestions.find((c) => c.id === s.id)
        let newValue = { ...s }
        if (newCustomization) {
          newValue.questionNumber = newCustomization.number
        }
        return newValue
      })

      const additionalRebuild = additionalQuestions.map((question) => {
        return buildAdditionalQuestion(question)
      })

      const additionalQuestionsUpdated = questions?.additionalQuestions?.map(
        (a) => {
          let newValue = { ...a }
          const updated = additionalRebuild.find(
            (t) =>
              t.section === newValue.section &&
              t.form === newValue.form &&
              t.organizationUuid === newValue.organizationUuid &&
              t.title === newValue.title
          )
          if (updated) {
            newValue = updated
          }
          return newValue
        }
      )

      const updatedMatrices = questions?.matrices?.map((m) => {
        let newValue = { ...m }
        const updated = formattedUpdated.find(
          (f) => f.title === newValue.title && f.kind === "matrix"
        )
        if (updated) {
          newValue.number = updated.number
        }
        return newValue
      })

      const updatedGroups = questions?.groups?.map((g) => {
        let newValue = { ...g }
        const updated = formattedUpdated.find(
          (f) => f.title && f.kind === "group"
        )
        if (updated) {
          newValue.number = updated.number
        }
        return newValue
      })

      updateQuestions({
        ...questions,
        additionalQuestions: additionalQuestionsUpdated,
        customizations: defaultUpdated,
        matrices: updatedMatrices,
        groups: updatedGroups,
      })
      setFormattedQuestions(formattedUpdated)
    } else {
      const group = questions?.groups.find(
        (g) => g.title === additionalQuestionToDelete?.questionGroup?.title
      )
      const groupQuestionsFiltered = group?.additionalQuestions?.filter(
        (q) => q.title !== additionalQuestionToDelete.title
      )
      const groupQuestionsUpdated = groupQuestionsFiltered.map((q, index) => {
        return { ...q, groupOrder: index + 1 }
      })
      const updatedGroup = questions?.groups.map((g) => {
        const newValue = { ...g }
        if (g.title === group?.title) {
          newValue.additionalQuestions =
            groupQuestionsUpdated?.length === 0
              ? undefined
              : groupQuestionsUpdated
        }
        return newValue
      })
      const markDeleted = questions?.additionalQuestions?.map((q) => {
        if (q.title === additionalQuestionToDelete.title) {
          return { ...q, deleted: true }
        } else {
          return q
        }
      })
      const markedWithNewNumbers = markDeleted?.map((q) => {
        const newAdditional = groupQuestionsUpdated.find(
          (d) => d.title === q.title
        )
        let newValue = { ...q }
        if (newAdditional) {
          newValue.groupOrder = newAdditional.groupOrder
        }
        return newValue
      })
      const readyToUpdate = markedWithNewNumbers?.map((q) => {
        return {
          id: q.id,
          organizationUuid: q.organizationUuid,
          form: q.form,
          section: q.section,
          subSection: q.subSection,
          title: q.title,
          oldTitle: q.oldTitle,
          description: q.description,
          type: q.type,
          options: q.options,
          enabled: q.enabled,
          required: q.required,
          number: q.number,
          organizations: organizations,
          selectedOrganizations: selectedOrganizations,
          isEnterprise: q.isEnterprise,
          enterpriseCustomization: q.enterpriseCustomization,
          deleted: q.deleted,
          questionGroup: q.questionGroup,
          groupOrder: q.groupOrder,
          conditionalDisplay: q.conditionalDisplay,
          conditionalRequired: q.conditionalRequired,
          conditionalSource: q.conditionalSource,
          conditionalType: q.conditionalType,
          conditionalValue: q.conditionalValue,
        }
      })

      updateQuestions({
        ...questions,
        additionalQuestions: readyToUpdate,
        groups: updatedGroup,
      })
    }

    setAdditionalQuestionToDelete(null)
  }
  const deleteGroup = () => {
    const matrixGroup = questions?.matrices.find(
      (g) => g.id === groupToDelete?.matrixGroup?.id
    )
    if (matrixGroup) {
      const matrixGroupsFiltered = matrixGroup?.questionGroups?.filter(
        (q) => q.title !== groupToDelete.title
      )
      const matrixGroupsUpdated = matrixGroupsFiltered.map((q, index) => {
        return { ...q, groupOrder: index + 1 }
      })
      const markDeleted = questions?.groups?.map((q) => {
        if (q.title === groupToDelete.title) {
          return { ...q, deleted: true }
        } else {
          return q
        }
      })
      const markedWithNewNumbers = markDeleted?.map((q) => {
        const newGroup = matrixGroupsUpdated.find((d) => d.title === q.title)
        let newValue = { ...q }
        if (newGroup) {
          newValue.groupOrder = newGroup.groupOrder
        }
        return newValue
      })
      updateQuestions({ ...questions, groups: markedWithNewNumbers })
    } else {
      const deletedGroups = questions?.groups.map((g) => {
        let newValue = { ...g }
        if (g.title === groupToDelete?.title) {
          newValue.deleted = true
        }
        return newValue
      })
      const numbersUpdated = formattedQuestions
        ?.filter((f) => f.title !== groupToDelete?.title)
        .map((f, index) => {
          return { ...f, number: index + 1 }
        })

      const updatedAdditionals = questions?.additionalQuestions?.map(
        (additional) => {
          const newNumber = numbersUpdated.find(
            (f) => f.kind === "additional" && f.title === additional.title
          )
          let newValue = { ...additional }
          if (newNumber) {
            newValue.number = newNumber.number
          }
          return newValue
        }
      )
      const updatedMatrices = questions?.matrices?.map((matrix) => {
        const newNumber = numbersUpdated.find(
          (f) => f.kind === "matrix" && f.title === matrix.title
        )
        let newValue = { ...matrix }
        if (newNumber) {
          newValue.number = newNumber.number
        }
        return newValue
      })
      const updatedGroups = deletedGroups.map((group) => {
        const newNumber = numbersUpdated.find(
          (f) => f.kind === "group" && f.title === group.title
        )
        let newValue = { ...group }
        if (newNumber) {
          newValue.number = newNumber.number
        }
        return newValue
      })
      const updatedDefault = questions?.customizations?.map((def) => {
        const newNumber = numbersUpdated.find((f) => f.id === def.id)
        let newValue = { ...def }
        if (newNumber) {
          newValue.questionNumber = newNumber.number
        }
        return newValue
      })
      updateQuestions({
        ...questions,
        customizations: updatedDefault,
        additionalQuestions: updatedAdditionals,
        matrices: updatedMatrices,
        groups: updatedGroups,
      })
    }

    setGroupToDelete(null)
  }
  const deleteMatrix = () => {
    const updatedMatrices = questions?.matrices.map((m) => {
      let newValue = { ...m }
      if (m.title === matrixToDelete?.title) {
        newValue.deleted = true
      }
      return newValue
    })
    const numbersUpdated = formattedQuestions
      ?.filter((f) => f.title !== matrixToDelete?.title)
      .map((f, index) => {
        return { ...f, number: index + 1 }
      })
    const updatedGroups = questions?.groups.map((g) => {
      let newValue = { ...g }
      if (g?.matrixGroup?.id === matrixToDelete.id) {
        newValue.matrixGroup = null
      }
      const newNumber = numbersUpdated.find(
        (n) => n?.title === g?.title && n.kind === "group"
      )
      if (newNumber) {
        newValue.number = newNumber.number
      } else {
        newValue.number = numbersUpdated?.length + 1
      }
      return newValue
    })
    const updatedAdditionals = questions?.additionalQuestions.map((a) => {
      let newValue = { ...a }
      const newNumber = numbersUpdated.find(
        (n) => n?.title === a?.title && n.kind === "additional"
      )
      if (newNumber) {
        newValue.questionGroup = null
        newValue.number = newNumber.number
      }
      return newValue
    })
    const updateDefault = questions?.customizations?.map((c) => {
      let newValue = { ...c }
      const newNumber = numbersUpdated.find(
        (n) => n?.title === c?.label && n.kind === "default"
      )
      if (newNumber) {
        newValue.questionNumber = newNumber.number
      }
      return newValue
    })
    updateQuestions({
      ...questions,
      additionalQuestions: updatedAdditionals,
      groups: updatedGroups,
      matrices: updatedMatrices,
      customizations: updateDefault,
    })
    setMatrixToDelete(null)
  }
  const confirmationFooterAdditionalQuestionToDelete = () => {
    return (
      <>
        <Button
          type="button"
          label="No"
          icon="pi pi-times"
          onClick={() => setAdditionalQuestionToDelete(null)}
          className="p-button-text"
        />
        <Button
          type="button"
          label="Yes"
          icon="pi pi-check"
          onClick={() => {
            deleteAdditional()
          }}
          className="p-button-text"
          autoFocus
        />
      </>
    )
  }
  const updateGroup = (groups) => {
    const updateNumbers = formattedQuestions
      // eslint-disable-next-line array-callback-return
      .filter((question) => {
        const groupInMatrix = groups.find(
          (g) => g.title === question.title && g.matrixId !== undefined
        )
        if (!groupInMatrix) {
          return question
        }
      })
      .map((question, index) => {
        return { ...question, number: index + 1 }
      })
    const updatedMatrices = questions?.matrices?.map((m) => {
      const updatedNumber = updateNumbers.find((n) => n.title === m.title)
      let newValue = { ...m }
      if (updatedNumber) {
        newValue.number = updatedNumber.number
      }
      return newValue
    })
    const updatedDefault = questions?.customizations?.map((m) => {
      const updatedNumber = updateNumbers.find((n) => n.title === m.title)
      let newValue = { ...m }
      if (updatedNumber) {
        newValue.number = updatedNumber.number
      }
      return newValue
    })
    const updatedAdditional = questions?.additionalQuestions?.map((m) => {
      const updatedNumber = updateNumbers.find(
        (n) =>
          n.title === m.title &&
          n.section === section &&
          n.form === interviewType
      )
      let newValue = { ...m }
      if (updatedNumber) {
        newValue.number = updatedNumber.number
      }
      if (m.questionGroup) {
        const updateDataGroup = groups.find(
          (g) =>
            g.title === m.questionGroup?.title ||
            g.oldTitle === m.questionGroup?.title
        )

        let newGroup = { ...m.questionGroup }
        if (updateDataGroup) {
          newValue.questionGroup = { ...newGroup, title: updateDataGroup.title }
        }
      }

      return newValue
    })
    const updatedGroups = groups.map((m) => {
      let newValue = { ...m }
      if (m.matrixGroup) {
        const numbersUpdated = groups
          ?.filter((g) => g?.matrixGroup?.title === m?.matrixGroup?.title)
          ?.map((g, index) => {
            return { ...g, groupOrder: index + 1 }
          })
        const updated = numbersUpdated?.find((n) => n.title === m.title)
        if (updated) {
          newValue.groupOrder = updated.groupOrder
        }
      } else {
        const updatedNumber = updateNumbers.find((n) => n.title === m.title)
        if (updatedNumber) {
          newValue.number = updatedNumber.number
        }
      }

      let updatedAdditionalQuestions
      if (newValue?.additionalQuestions?.length > 0) {
        updatedAdditionalQuestions = newValue?.additionalQuestions.map((a) => {
          let newAdditional = { ...a }
          let newQuestionGroup = { ...a.questionGroup }
          newQuestionGroup.title = newValue.title
          newAdditional.questionGroup = newQuestionGroup
          return newAdditional
        })
      }
      newValue.additionalQuestions = updatedAdditionalQuestions
      return newValue
    })
    updateQuestions({
      ...questions,
      groups: updatedGroups,
      matrices: updatedMatrices,
      additionalQuestions: updatedAdditional,
      customizations: updatedDefault,
    })
  }
  const confirmationFooterMatrixToDelete = () => {
    return (
      <>
        <Button
          type="button"
          label="No"
          icon="pi pi-times"
          onClick={() => setMatrixToDelete(null)}
          className="p-button-text"
        />
        <Button
          type="button"
          label="Yes"
          icon="pi pi-check"
          onClick={() => {
            deleteMatrix()
          }}
          className="p-button-text"
          autoFocus
        />
      </>
    )
  }
  const confirmationFooterGroupToDelete = () => {
    return (
      <>
        <Button
          type="button"
          label="No"
          icon="pi pi-times"
          onClick={() => setGroupToDelete(null)}
          className="p-button-text"
        />
        <Button
          type="button"
          label="Yes"
          icon="pi pi-check"
          onClick={() => {
            deleteGroup()
          }}
          className="p-button-text"
          autoFocus
        />
      </>
    )
  }
  return (
    <>
      {confirmDialog()}
      <div>
        {questionsButtons()}
        <OrderList
          value={formattedQuestions}
          itemTemplate={itemTemplate}
          className={`additional-order-list custom-item ${
            disabled && "additional-order-list-disabled"
          }`}
          dataKey="title"
          onChange={(e) => {
            if (!blocked) {
              setNumbers(e.value)
            } else {
              setShowConfirm(true)
            }
          }}
          header={listHeader()}
          listStyle={{ paddingLeft: "0rem" }}
        ></OrderList>
        <AddAdditionalQuestion
          additionalEditing={additionalEditing}
          disabled={disabled}
          interviewType={interviewType}
          number={formattedQuestions?.length + 1}
          organizationError={organizationError}
          organizations={organizations}
          section={section}
          selectedOrganizations={selectedOrganizations}
          setAdditionalSaving={setAdditionalEditing}
          setOrganizationError={setOrganizationError}
          setShowAddAdditional={setShowAddAdditional}
          showAddAdditional={showAddAdditional}
          setCustomizationChanges={setCustomizationChanges}
          defaultQuestions={questions}
          groups={questions?.groups?.filter(
            (g) => g.section === section && g.form === interviewType
          )}
          matrices={questions?.matrices?.filter(
            (m) => m.section === section && m.form === interviewType
          )}
          questions={questions}
          updateQuestions={updateQuestions}
          formattedQuestions={formattedQuestions}
          changeAdditionalPosition={changeAdditionalPosition}
        />
        <AddMatrix
          interviewType={interviewType}
          number={formattedQuestions.length + 1}
          organizations={organizations}
          section={section}
          selectedOrganizations={selectedOrganizations}
          setShow={setShowAddMatrix}
          show={showAddMatrix}
          matrixEditing={matrixEditing}
          questions={questions}
          updateQuestions={updateQuestions}
        />
        <AddGroup
          interviewType={interviewType}
          number={formattedQuestions.length + 1}
          organizations={organizations}
          section={section}
          selectedOrganizations={selectedOrganizations}
          setShow={setShowAddGroup}
          show={showAddGroup}
          matrices={questions?.matrices?.filter(
            (m) => m.section === section && m.form === interviewType
          )}
          groupEditing={groupEditing}
          questions={questions}
          updateGroup={updateGroup}
        />
        <EditDefaultQuestion
          setShowEditDefault={setShowEditDefault}
          showEditDefault={showEditDefault}
          defaultQuestion={editDefault}
          updateShowCustomizations={updateShowCustomizations}
          questions={questions}
          updateQuestions={updateQuestions}
          interviewType={interviewType}
          section={section}
        />
        <Dialog
          header="Delete additional question"
          visible={additionalQuestionToDelete !== null}
          onHide={() => setAdditionalQuestionToDelete(null)}
          style={{ width: "350px" }}
          modal
          footer={confirmationFooterAdditionalQuestionToDelete()}
        >
          <div className={styles.cancelDialogText}>
            <i
              className="pi pi-exclamation-triangle"
              style={{ fontSize: "2rem" }}
            />
            <span
              className={styles.ml1}
            >{`Do you want to delete ${additionalQuestionToDelete?.title}?`}</span>
          </div>
        </Dialog>
        <Dialog
          header="Delete group"
          visible={groupToDelete !== null}
          onHide={() => setGroupToDelete(null)}
          style={{ width: "350px" }}
          modal
          footer={confirmationFooterGroupToDelete()}
        >
          <div className={styles.cancelDialogText}>
            <i
              className="pi pi-exclamation-triangle"
              style={{ fontSize: "2rem" }}
            />
            <span
              className={styles.ml1}
            >{`Do you want to delete ${groupToDelete?.title}?`}</span>
          </div>
        </Dialog>
        <Dialog
          header="Delete matrix"
          visible={matrixToDelete !== null}
          onHide={() => setMatrixToDelete(null)}
          style={{ width: "350px" }}
          modal
          footer={confirmationFooterMatrixToDelete()}
        >
          <div className={styles.cancelDialogText}>
            <i
              className="pi pi-exclamation-triangle"
              style={{ fontSize: "2rem" }}
            />
            <span
              className={styles.ml1}
            >{`Do you want to delete ${matrixToDelete?.title}?`}</span>
          </div>
        </Dialog>
        {questionsButtons()}
      </div>
    </>
  )
}
export default Questions
